// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_3tjO-","ico":"_3dyFZ","title":"_24MKJ","id":"_197o7"};